export default __webpack_public_path__ + "static/media/k1.ef9e7f83.jpg";